<template>
  <div>
    密码重置
    <div>
      <b-alert show v-if="successMessage" variant="success">
        {{ successMessage }}
      </b-alert>
      <el-form ref="form" :model="resetRequest" label-position="top">
        <el-form-item label="邮箱地址">
          <el-input v-model="resetRequest.email" :required="true"></el-input>
        </el-form-item>
        <el-form-item label="密 码">
          <el-input
            type="password"
            :required="true"
            v-model="resetRequest.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input
            type="password"
            v-model="resetRequest.password_confirmation"
            :required="true"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <!--                            <div class="form-group{{ $errors->has('password') ? ' has-error' : '' }}">-->
        <el-form-item>
          <el-button @click="resetPassword">重置密码</el-button>
        </el-form-item>
      </el-form>

      <div>
        <b-alert show v-if="this.message" variant="danger">
          {{ this.message }}
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "Login.vue",
  props: ["token"],
  data() {
    return {
      resetRequest: {
        email: "",
        password: "",
        password_confirmation: ""
      },
      message: "",
      successMessage: ""
    };
  },
  methods: {
    ...mapMutations(["setLoading"]),
    resetPassword: function() {
      this.message = "";
      this.resetRequest.token = this.token;
      this.setLoading(true);
      this.$http
        .post("/password/reset", this.resetRequest)
        .then(() => {
          this.setLoading(false);
          this.successMessage = "密码已重置！";
        })
        .catch(error => {
          this.setLoading(false);
          if (error.response.status === 500) {
            this.message = JSON.stringify(error.response.data.errors);
          } else {
            this.message = "网络出错，请稍后重试！";
          }
        });
    }
  }
};
</script>

<style scoped></style>
